import { useQueryClient } from 'react-query';

import { useMutationSetReport } from 'api/mutations/setReport.mutation';

export type UseCreateFromScratchReportModalProvider = ReturnType<typeof useCreateFromScratchReportModalProvider>;

export const useCreateFromScratchReportModalProvider = () => {
    const instance = useMutationSetReport();
    const queryClient = useQueryClient();

    return {
        api: {
            setReport: {
                instance,
            },
            queryClient,
        },
    };
};
